/**
 * On screens narrower than 1200px the control layout scrolls back to the frame (or the header above it) after each pick, so the
 * shopper sees the change. The redesign (B) keeps the shopper in its steps, and turns this off once when it mounts
 * (setPreviewScroll). Every selection handler that scrolls calls scrollToPreview with the element the control scrolled to.
 */
let previewScroll = true;

export const setPreviewScroll = (on: boolean): void => {
    previewScroll = on;
};

export const scrollToPreview = (id: string): void => {
    if (previewScroll && window.innerWidth < 1200) {
        const d = document.getElementById(id) as HTMLDivElement;
        if (d) {
            d.scrollIntoView();
        }
    }
};
